<template>
  <v-row
    class="fill-height"
    justify="center"
    align="center"
    no-gutters
  >
    <v-col cols="12" md="4">
      <v-form ref="login">
        <v-card>
          <v-toolbar color="#002E4F" dark elevation="0">
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="username"
              label="Username"
              :rules="[v => !!v || 'Field is required']"
            />
            <v-text-field
              v-model="password"
              label="Passsword"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[v => !!v || 'Field is required']"
              @click:append="showPassword = !showPassword"
            />
            <div class="mb-2" />
            <v-btn block dark :loading="loading" color="#002E4F" @click="login">Login</v-btn>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent, reactive, ref, toRefs } from '@vue/composition-api';
import { useStore } from '@/utils/use-store';

export default defineComponent({
  name: 'NotAuthorized',

  setup(props, context) {
    const store = useStore();
    const user = reactive({
      username: '',
      password: ''
    });

    const showPassword = ref(false);
    let loading = ref(false);

    const login = async () => {
      if (context.refs.login.validate()) {
        try {
          loading.value = true;
          await store.dispatch('signIn', user);
        } catch (e) {
          const message = e.response ? e.response.data.message : e.message;
          throw new Error(message);
        } finally {
          loading.value = false;
        }
      }
    };

    return {
      ...toRefs(user),
      showPassword,
      loading,
      login
    };
  }
});
</script>
